<template>
  <div class="style-text">
    <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/02/20/rB8LrmO9T9uAYGlHAAWfYRXlQK4297.png" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
  .style-text {
    img {
      width: 375px;
      height: 100%;
    }
  }
</style>